const ITEMS = [
  "Executive Search",
  "Permanent Hiring",
  "Talent Acquisition",
  "IT Recruitment",
  "Non-IT Staffing",
  "Healthcare Recruitment",
  "BFSI Recruitment",
  "Bulk Hiring Drives",
  "RPO Solutions",
  "Leadership Hiring",
];

const Marquee = () => {
  const loop = [...ITEMS, ...ITEMS];
  return (
    <section
      data-testid="marquee"
      aria-hidden="true"
      className="relative overflow-hidden border-y border-gold-soft bg-gold-light py-8 md:py-10"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {loop.map((item, i) => (
          <div key={`${item}-${i}`} className="flex items-center">
            <span className="px-8 pb-2 font-display text-3xl font-light leading-tight tracking-tight text-green-primary md:text-5xl">
              {item}
            </span>
            <span className="px-8 text-2xl text-gold-primary md:text-3xl">&#8734;</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Marquee;
